var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_94",
    "data-name": "Group 94",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.289,
    height: 69.246,
    viewBox: "0 0 65.289 69.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.911,
    y2: 1.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 65.289,
    height: 69.246,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1.978,9.892A1.979,1.979,0,0,0,0,11.871v8.9A10.9,10.9,0,0,0,10.882,31.655h.191a21.75,21.75,0,0,0,14.647,14.7v7.059h-2.6a6.314,6.314,0,0,0-6.306,6.306v5.565H14.344a1.978,1.978,0,0,0,0,3.957h36.6a1.978,1.978,0,0,0,0-3.957H48.472V59.724a6.314,6.314,0,0,0-6.306-6.306h-2.6V46.359a21.75,21.75,0,0,0,14.647-14.7h.191A10.9,10.9,0,0,0,65.289,20.774v-8.9a1.979,1.979,0,0,0-1.978-1.978H54.959V3.957h2.8a1.978,1.978,0,0,0,0-3.957H7.527a1.978,1.978,0,0,0,0,3.957h2.8V9.892ZM3.957,20.774V13.849H10.33v12.4c0,.48.026.959.057,1.427a6.928,6.928,0,0,1-6.43-6.9M44.515,59.724v5.565H20.774V59.724a2.348,2.348,0,0,1,2.349-2.349H42.166a2.348,2.348,0,0,1,2.349,2.349m-8.9-6.306H29.677v-6.2a22.656,22.656,0,0,0,5.935,0Zm25.72-39.569v6.925a6.924,6.924,0,0,1-6.43,6.9c.03-.468.057-.947.057-1.427v-12.4ZM51,3.957V26.245c0,9.491-8.233,17.209-18.357,17.209S14.287,35.736,14.287,26.245V3.957Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M21.558,22.269,19.734,27.88a1.979,1.979,0,0,0,3.046,2.211l4.771-3.468,4.771,3.468a1.979,1.979,0,0,0,3.046-2.211l-1.824-5.611L38.313,18.8a1.977,1.977,0,0,0-1.165-3.576H31.255L29.431,9.615a1.978,1.978,0,0,0-3.762,0l-1.824,5.611H17.952A1.977,1.977,0,0,0,16.787,18.8Zm3.725-3.086a1.974,1.974,0,0,0,1.881-1.37l.386-1.18.386,1.18a1.974,1.974,0,0,0,1.881,1.37h1.246l-1.01.732a1.977,1.977,0,0,0-.716,2.211l.383,1.184-1.005-.732a1.979,1.979,0,0,0-2.329,0l-1.005.732.386-1.184a1.977,1.977,0,0,0-.72-2.211l-1.01-.732Z",
    transform: "translate(5.095 2.632)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon8);
export default __webpack_public_path__ + "static/media/social_icon8.f2ff34800262cca98f7228018b418df7.svg";
export { ForwardRef as ReactComponent };